'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ../~/es-errors/index.js
// module id = 1543
// module chunks = 1